import createVueComponent from '../createVueComponent';

const ArrowUpLeftFromCircle = createVueComponent('ArrowUpLeftFromCircleIcon', [
  ['path', { d: 'M2 8V2h6', key: 'hiwtdz' }],
  ['path', { d: 'm2 2 10 10', key: '1oh8rs' }],
  ['path', { d: 'M12 2A10 10 0 1 1 2 12', key: 'rrk4fa' }],
]);

export default ArrowUpLeftFromCircle;
